import React, { type FC } from 'react';
import {
  UiDrawer,
  UiDrawerOverlay,
  UiDrawerContent,
  UiDrawerBody,
  UiDrawerCloseButton,
  type UiDrawerProps,
  UiStack,
  UiButton,
  UiHStack
} from '@/lib/ui';
import Cart from './Cart';
import InfoBox from '@/registration/component/InfoBox';

export interface DrawerProps extends Omit<UiDrawerProps, 'children'> {}

const Drawer: FC<DrawerProps> = (props) => {
  return (
    <UiDrawer placement={'right'} size={'lg'} {...props}>
      <UiDrawerOverlay />
      <UiDrawerContent bgColor={'gray.100'}>
        <UiDrawerCloseButton size={'lg'} fontWeight={'bold'} color={'primary.500'} />
        <UiDrawerBody px={0} pb={16} alignItems={'stretch'}>
          <UiStack
            px={{ base: 6, lg: 8 }}
            pt={8}
            pb={16}
            flexGrow={1}
            spacing={8}
          >
            <InfoBox
              title={'Shopping cart'}
            />
            <Cart />
          </UiStack>
        </UiDrawerBody>
      </UiDrawerContent>
    </UiDrawer>
  );
};

export default Drawer;
